import firebase from 'firebase/app';
import 'firebase/auth';

const firebaseConfig = {
  apiKey: wwfconfigs.FIREBASE_AUTH_API_KEY,
  projectId: wwfconfigs.FIREBASE_AUTH_PROJECT_ID,
};
const firebaseAuth = firebase.initializeApp(firebaseConfig, 'firebaseAuth');

// Set persisitance to 
firebaseAuth.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

const state = {
  user: null,
  ssoId: null,
};

function readCookie(name) {
  return (name = new RegExp('(?:^|;\\s*)' + ('' + name).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') + '=([^;]*)').exec(document.cookie)) && name[1];
}

function setCookie(cookieName, id) {
  // Set the cookie
  const expiry = new Date().setMonth(new Date().getMonth() + 12);
  const domain = wwfconfigs.NODE_ENV === 'development' ? 'localhost' : 'domain=.wwf.org.au';
  document.cookie = `${cookieName}=${id};expires=${expiry};${domain};path=/`;
}

const actions = {
  login({ commit }) {
    return new Promise((resolve, reject) => {
      // Read the cookie if it exists
      const cookieName = '_wwf-token';
      const cookieContent = readCookie(cookieName);

      if (cookieContent != null) {
        setCookie(cookieName, cookieContent);

        commit('login', {
          ssoId: cookieContent
        });
        resolve({
          data: {
            ssoId: cookieContent,
          },
        });

      } else {

        // If it doesn't exists, create auth
        firebaseAuth
          .auth()
          .signInAnonymously()
          .then((userCredential) => {
            console.log(`Firebase Anon Auth - ${userCredential.user.uid}`);

            setCookie(cookieName, userCredential.user.uid);

            commit('login', {
              ssoId: userCredential.user.uid,
              user: userCredential.user,
            });
            resolve({
              data: {
                ssoId: userCredential.user.uid,
                data: userCredential.user,
              },
            });

          })
          .catch((err) => {
            console.error('Firebase auth Error', err);
            reject(err);
          });
      }
    });
  },
};

const mutations = {
  login(state, response) {
    console.log(`Firebase Login - ${response.ssoId}`);
    state.ssoId = response.ssoId;
    state.user = response.user;
  },
};

const getters = {
  isLoggedIn: (state) => !!state.user,
  currentUser: (state) => state.user,
  ssoId: (state) => state.ssoId
    ? state.ssoId
    : state.user
      ? state.user.uid
      : null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js